const { CLIENT_ID, ISSUER, OKTA_TESTING_DISABLEHTTPSCHECK, BACKEND_HOST} = process.env

const BASENAME = process.env.NODE_ENV === 'production' ? '' : '';
const REDIRECT_URI = `${window.location.origin}${BASENAME}/login/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    testing: {
      disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK
    }
  },
  resourceServer: {
    devicesUrl: `https://${BACKEND_HOST}/api/assets`,
    usersUrl: `https://${BACKEND_HOST}/api/users`,
    reassignUrl: `https://${BACKEND_HOST}/api/assets/<asset_id>/reassign`
  },
  app: {
    basename: BASENAME
  }
}
